import { flatMap } from "lodash";
import { Col, Image, Row } from "react-bootstrap";
import { useWatch } from "react-hook-form";
import { useProduct } from "../../../adapters/uplist";
import { STANDARD_FP_ADDON_IMAGES } from "../../../assets/images/samples";
import { useFormDetailsState } from "../../../context/FormDetailsContext";
import { isInternal } from "../../../helpers";
import { FLOORPLAN_COLOR_SKUS } from "../../../helpers/constants";
import { useWindowSize } from "../../../hooks";
import { BlockCheckbox, Button, InlineCheckbox } from "../../fields";
import AddOnSection from "../AddOnSection";
import { FurnishedFpProduct } from "./FurnishedFpProduct";

const useSelectedColorLetter = () => {
  const values = useWatch({ name: FLOORPLAN_COLOR_SKUS });
  const selected_sku = FLOORPLAN_COLOR_SKUS[values.indexOf(true)];
  const { data: product } = useProduct(selected_sku);
  return product?.name.split(" -")[0].slice(-1) || "none";
};

export const StandardAddons = () => {
  const { data: colorFPProduct } = useProduct("2012");
  const { isNotSmall } = useWindowSize();
  return (
    <div className="mb-5">
      {!isInternal() && (
        <InlineCheckbox
          sku="standard_fp_addons"
          label="Standard Floor Plan Add-Ons"
          description="Add colour and furnishings to your Basic Floor Plan, in our usual fantastic same-day turnaround time. Select your products to see a sample below."
          labelClassName="h2 text-black"
          isNew
        />
      )}
      <AddOnSection
        show_skus={["standard_fp_addons"]}
        addon_skus={["color_floor_plan", "2017", ...FLOORPLAN_COLOR_SKUS]}
      >
        <Row>
          <Col xs={12} sm={4} className="mb-4">
            <div className="mb-3">
              <BlockCheckbox
                sku="color_floor_plan"
                label="Colour Floor Plan"
                description={colorFPProduct.description}
                additional_price={colorFPProduct.price}
                defaultValue={!isInternal()}
                short_labels={!isNotSmall}
                col={false}
              />
            </div>
            <AddOnSection
              show_skus={["color_floor_plan"]}
              addon_skus={FLOORPLAN_COLOR_SKUS}
              hideInternal
            >
              <FloorPlanButtons />
            </AddOnSection>
            <FurnishedFpProduct />
          </Col>
          <FloorplanImages />
        </Row>
      </AddOnSection>
    </div>
  );
};

const FloorPlanButtons = () => {
  return (
    <div className="mb-4">
      <h2 className="mb-2">Choose Your Palette</h2>
      {FLOORPLAN_COLOR_SKUS.map((sku, index) => (
        <Button
          key={sku}
          sku={sku}
          label={(label) => label.replace("Colour Floor Plan ", "")}
          defaultValue={index === 0}
        />
      ))}
    </div>
  );
};

const FloorplanImages = () => {
  const color_letter = useSelectedColorLetter();
  const furnishedSelected = useWatch({ name: "2017" });
  const {
    footerHeight: { order_form },
  } = useFormDetailsState();
  return (
    <Col xs={12} sm={8}>
      {flatMap(STANDARD_FP_ADDON_IMAGES, (v) => [v.standard, v.furnished]).map(
        (url) => {
          const selected_url =
            STANDARD_FP_ADDON_IMAGES[color_letter]?.[
              furnishedSelected ? "furnished" : "standard"
            ];
          return (
            <Image
              key={url}
              src={url}
              style={{
                maxHeight: `calc(100vh - 3rem - ${order_form}px)`,
                maxWidth: "100%",
                position: "sticky",
                top: 0,
                display: url === selected_url ? "inline" : "none",
              }}
            />
          );
        }
      )}
    </Col>
  );
};
